<template>
    <div>   
        <van-tabbar v-model="active" @change="onChange" class="footer-footer">
            <van-tabbar-item class="footer"> 
                <div class="footer-wrap">
                    <img class="footer-wrap-img" src="~statics/mobileShouye/home.png" alt="">
                </div>
                <span class="footer-wrap-title">{{$t("areaIndex").home}}</span>
            </van-tabbar-item>
            <van-tabbar-item class="footer">
                <div class="footer-wrap">
                    <img class="footer-wrap-img" :src="this.zxtImg" alt="">
                </div>
                <span class="footer-wrap-title">{{$t("areaIndex").zxt}}</span>
            </van-tabbar-item>
            <van-tabbar-item class="footer"> 
                <div class="footer-wrap">
                    <img class="footer-wrap-img"  :src="this.zltImg" alt="">
                </div>
                <span class="footer-wrap-title">{{$t("areaIndex").zlt}}</span>
            </van-tabbar-item>
            <van-tabbar-item class="footer">
                <div class="footer-wrap">
                    <img class="footer-wrap-img" :src="this.hytmg" alt="">
                </div>
                <span class="footer-wrap-title">{{$t("areaIndex").hyt}}</span>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>

export default {
    props: {
        
    },
    watch: {
        $route: {
            handler(route) {
                // console.log(route)
                if(route.path == "/mobileConsult" ){
                    this.active = 1
                }
                if(route.path == "/mobilecomponent" ){
                    this.active = 2
                }
                 if(route.path == "/mobileMeetHall" ){
                    this.active = 3
                }
                if(route.path == "/mobileConsult"){
                    this.zxtImg = require('statics/mobileShouye/zxt-active.png')
                }else{
                    this.zxtImg = require('statics/mobileShouye/zxt.png')
                }
                if(route.path == "/mobilecomponent"){
                    this.zltImg = require('statics/mobileShouye/zlt-active.png')
                }else{
                    this.zltImg = require('statics/mobileShouye/zlt.png')
                }
                if(route.path == "/mobileMeetHall"){
                    this.hytmg = require('statics/mobileShouye/hyt-active.png')
                }else{
                    this.hytmg = require('statics/mobileShouye/hyt.png')
                }
            },
		    immediate: true,
        },
        
    },
    data(){
        return{
            active: '',
            exhibition_id: '',
            zltImg: '',
            hytmg: '',
            zxtImg: ''
        }
    },
    created() {
        this.exhibition_id = this.$route.query.exhibition_id;
    },
    methods: {
        onChange(index) {
            switch (index){
                case 0:
                    this.$router.push({
                        path: '/mobileExhibitors',
                    })
                    this.active = 0
                    break
                case 1:
                    this.$router.push({
                        path: '/mobileConsult',
                        query: {
                            // company_id: _id,
                            exhibition_id: this.exhibition_id,
                            // instance_id: _vhall_id
                        }
                    })
                    this.active = 1
                    break;
                case 2:
                    this.$router.push({
                        path: '/mobilecomponent',
                        query: {
                            // company_id: _id,
                            exhibition_id: this.exhibition_id,
                            // instance_id: _vhall_id
                        }
                    })
                    this.active = 2
                    break;
                case 3:
                    this.$router.push({
                        path: '/mobileMeetHall',
                        query: {
                            // company_id: _id,
                            exhibition_id: this.exhibition_id,
                            // instance_id: _vhall_id
                        }
                    })
                    this.active = 3
                    break;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
/deep/ .van-tabbar-item--active{
    .footer-wrap-img{
        color: #1989fa;
    }
    
}
/deep/.van-tabbar-item{
    display: flex;
    flex-direction: unset;
    align-items: unset;
}
.footer{
    .footer-wrap{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: .1rem;
        .footer-wrap-img{
            width: .48rem;
            height: .48rem;
        }
    } 
}
.footer-footer{
    width: 100%;
    height: 1rem;
    opacity: 0.8;
    // background: #194b96;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileConsult/components/Footers.vue